import { createContext } from 'react'

import { Dispatcher } from 'app/types/dispatcher'
import { LicenseType } from './types'

interface LicensesContextType {
  setSelectedLicense: Dispatcher<LicenseType | null>
  setIsOpenReclaimModal: Dispatcher<boolean>
  setIsOpenTransferModal: Dispatcher<boolean>
}

export const LicensesContext = createContext<LicensesContextType>({
  setSelectedLicense: () => {},
  setIsOpenReclaimModal: () => {},
  setIsOpenTransferModal: () => {},
})
